import { Quaternion, Vector3, Web3DViewer } from '@technology/web3d';
import { CapabilityProviderBase } from '@trimble/web3d-providers';
import { enableTools, NavigationTool } from '../../helpers/web3d-tool-helper';
import { CapabilityBase } from './capability-base';
import { CapabilityCategory } from './models/capability-category';

/**
 * Capability for a single viewer which is used for changing how the user navigates.
 * Setting the Web3D tools via abstract `requiredWeb3DTools` needed for navigation is required.
 */
export abstract class NavigationalCapabilityBase extends CapabilityBase {
  public override category: CapabilityCategory = CapabilityCategory.Navigation;

  protected abstract requiredWeb3DTools: NavigationTool[] | null;

  constructor(
    protected viewer: Web3DViewer,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    provider?: CapabilityProviderBase<any>
  ) {
    super(provider);
  }

  public override activate(): boolean {
    const wasSetActive = super.activate();
    if (wasSetActive) {
      this.enableRequiredTools();
    }
    return wasSetActive;
  }

  /**
   * Moves to a world-position target while staying in this navigation mode.
   *
   * Returns false when the mode cannot represent the target, which lets the
   * caller fall back to activating a different navigation mode. Declining is
   * the default so a mode only opts in once it can honour the target without
   * losing its own state.
   */
  public tryNavigateToWorldPosition(
    _position: Vector3,
    _quaternion?: Quaternion
  ): boolean {
    return false;
  }

  private enableRequiredTools(): void {
    enableTools(this.viewer, this.requiredWeb3DTools);
  }
}
